<div *ngIf="qID == '7'" [attr.aria-label]="attAriaLabel">
  <!-- <fieldset> -->
    <!-- <div class="row text-center"> -->
      <!--<div class="col">
        {{"BORROWERS_DETAILS.QUESTION23.FULL_NAME"|translate}}
      </div>
      <div class="col">
        {{"BORROWERS_DETAILS.QUESTION23.TEL"|translate}}
      </div>
      <div class="col">
        {{"BORROWERS_DETAILS.QUESTION23.BIRTH_DATE"|translate}}
      </div>
      <div class="col">
        {{"BORROWERS_DETAILS.QUESTION23.ID_NUM"|translate}}
      </div>
      <div class="col">
        {{"BORROWERS_DETAILS.QUESTION23.PROXIMITY"|translate}}
      </div> -->
    <!-- </div> -->
    <div *ngIf="!isloading">
        <app-add-borrower [msgArr]="msgArr" [ifShowMessages]="ifShowMessages" *ngFor="let borrower of borrowersArray.controls; let i=index" [index]="i" [borrower]="borrower" (removed)="remove($event)"
                          [qID]="qID" [displayErrors]="displayErrors" [showRemove]="showRemove && (borrowersArray.controls.length-1 == i)">
        </app-add-borrower>
    </div>
  <div *ngIf="isloading" class="mb-2" >
      <app-loader-page   [isloading]="isloading"></app-loader-page>
      </div>

  <!-- </fieldset> -->
	
  <div class="d-flex justify-content-center">
		<div *ngIf="borrowersArray.length > 0 && borrowersArray.length<maxBorrowerCount"  class="m-add-line-btn w-100" (click)="addAndCheckBorrower()" role="button" tabindex="0" (keypress)="simulateClick($event)">
      <!-- <app-messages *ngIf="isDisplayed" [msgArr]="errorMessageOnComponent"></app-messages> -->
      <span>{{"USER_DETAILS.Q7.BUTTON_ADD_AND_SAVE"|translate}}</span>
    </div>
    <div *ngIf="borrowersArray.length === 0"  class="m-add-line-btn w-100" (click)="addBorrower()" role="button" tabindex="0" (keypress)="simulateClick($event)">
      <i class="fa fa-plus" aria-hidden="true"></i>
      <span>{{"USER_DETAILS.Q7.BUTTON_ADD"|translate}}</span>
    </div>
  </div>
</div>

<fieldset *ngIf="qID == '29'">
 <!-- <div class="row text-center">
    
    <div class="col">
      {{"BORROWERS_DETAILS.QUESTION29.NAME_TITLE"|translate}}
    </div>
    <div class="col">
      {{"BORROWERS_DETAILS.QUESTION29.ADDRESS_TITLE"|translate}}
    </div>
    <div class="col">
      {{"BORROWERS_DETAILS.QUESTION29.CHILDREN_TITLE"|translate}}
    </div>
    <div class="col">
      {{"BORROWERS_DETAILS.QUESTION29.MARITAL_STATUS_TITLE"|translate}}
    </div>
  </div>
  -->
  <app-add-borrower [status]="status" *ngFor="let borrower of borrowersArray.controls; let i=index" (removed)="borrowersArray.removeAt($event);removeError()" [childrenNumber]="childrenNumber" [maritalStatus]="maritalStatus" [index]="i" [borrower]="borrower" [qID]="qID"
    [displayErrors]="displayErrors" (offError)="removeError()">
  </app-add-borrower>
</fieldset>


// WEBPACK FOOTER //
// ./src/app/borrowers-array/borrowers-array.component.html